"use strict";

define(['marionette', 'backbone', './template.html'], function (MN, Backbone, popoverTemplate) {
  return MN.ItemView.extend({
    template: popoverTemplate,
    events: {
      mouseenter: 'show',
      mouseleave: 'hide'
    },
    options: {
      popoverMessage: '',
      cssClass: ''
    },
    templateHelpers: function templateHelpers() {
      return {
        popoverMessage: this.options.popoverMessage,
        cssClass: this.options.cssClass
      };
    },
    hide: function hide() {
      var self = this;
      clearTimeout(self.hideTimeout);
      self.hideTimeout = setTimeout(function () {
        self.$el.fadeOut();
      }, 300);
    },
    show: function show() {
      this.clearTimeout();
    },
    clearTimeout: function (_clearTimeout) {
      function clearTimeout() {
        return _clearTimeout.apply(this, arguments);
      }

      clearTimeout.toString = function () {
        return _clearTimeout.toString();
      };

      return clearTimeout;
    }(function () {
      clearTimeout(this.hideTimeout);
    }),
    setPosition: function setPosition(topPosition, leftPosition) {
      this.$el.css({
        position: 'absolute',
        top: topPosition,
        left: leftPosition
      }).stop().fadeIn();
    },
    setLinkUrl: function setLinkUrl(linkUrl) {
      if (!linkUrl) {
        return;
      }

      this.model.set('linkUrl', linkUrl);
    },
    initialize: function initialize() {
      this.model = new Backbone.Model({
        linkUrl: this.options.linkUrl
      });
      this.model.on('change:linkUrl', this.render);
    }
  });
});